import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { useAddUserButton } from "./hooks";

function AddUsersButton({ onClick }) {
  const { enabled } = useAddUserButton();

  if (enabled) {
    return <Button primary content="Invite Users" onClick={onClick} />;
  }

  return null;
}

AddUsersButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default AddUsersButton;
